module.exports = __webpack_public_path__ + "static/media/w2-t.2aeb2b61.jpg";